export const STATUS_CONFERENCIA_FINANCEIRA = {
  ABERTA: 'A',
  FECHADA: 'F',
  CANCELADA: 'C'
}

export function getLabelStatusConferenciaFinanceira(status) {
  const labels = {
    [STATUS_CONFERENCIA_FINANCEIRA.ABERTA]: 'Em Andamento',
    [STATUS_CONFERENCIA_FINANCEIRA.FECHADA]: 'Fechada',
    [STATUS_CONFERENCIA_FINANCEIRA.CANCELADA]: 'Cancelada'
  }

  return labels[String(status || '').trim()] || 'Nao Informado'
}

export function getVariantStatusConferenciaFinanceira(status) {
  const variants = {
    [STATUS_CONFERENCIA_FINANCEIRA.ABERTA]: 'warning',
    [STATUS_CONFERENCIA_FINANCEIRA.FECHADA]: 'success',
    [STATUS_CONFERENCIA_FINANCEIRA.CANCELADA]: 'danger'
  }

  return variants[String(status || '').trim()] || 'secondary'
}

export function getOptionsStatusConferenciaFinanceira() {
  return [
    { value: '', text: 'Todos' },
    { value: STATUS_CONFERENCIA_FINANCEIRA.ABERTA, text: 'Em Andamento' },
    { value: STATUS_CONFERENCIA_FINANCEIRA.FECHADA, text: 'Fechada' },
    { value: STATUS_CONFERENCIA_FINANCEIRA.CANCELADA, text: 'Cancelada' }
  ]
}


// WEBPACK FOOTER //
// ./src/utils/conferenciaFinanceiraStatus.js